<div
  class="flex items-center w-full md:w-fit
{{ classNames }}"
  appClickOutside
  (clickOutside)="clickedOutside()"
>
  <div
    *ngIf="isOpen && backdrop"
    class="fixed z-modal-backdrop inset-0 bg-blue opacity-50"
    (click)="close()"
  ></div>

  <div class="relative w-full md:w-fit {{ isOpen && backdrop ? 'z-modal' : '' }} ">
    <button
      *ngIf="caller === '_GLOBAL'"
      class="h-12 uppercase"
      mat-button
      color="primary"
      id="dropdownTrigger"
      (click)="openfilterSelect()"
    >
      <div class="flex items-center gap-2">
        <img appImg src="assets/svg/filter.svg" class="h-6 w-6" alt="arrow" />
        <span>{{ pickValue?.label }}</span>
        <img
          appImg
          src="assets/svg/arrow-bottom.svg"
          class="h-6 w-6 {{ isOpen ? 'rotate-180' : '' }}"
          alt="arrow"
        />
      </div>
    </button>
    <ul
      *ngIf="isOpen"
      id="dropdown"
      class="absolute w-fit bg-light-gray max-h-[192px] {{
        formRight ? 'right-0' : 'left-0'
      }} rounded-lg shadow-inner-blue-sm overflow-auto mt-1 z-dropdown"
    >
      <app-option
        *ngFor="let option of options"
        [value]="option.value"
        [label]="option.label"
        [isSelected]="option.label === pickValue?.label"
        (selectEvent)="selectedOption($event)"
        class="{{ optionWidth ? optionWidth : ' w-75' }} h-12 "
        classNames="{{ optionWidth ? optionWidth : ' w-75' }} h-12"
      >
        <span *ngIf="caller === '_GLOBAL'">{{ option.label }}</span>
      </app-option>
    </ul>
  </div>
</div>
